import { useEffect, useState } from 'react';
import { getAnimationDuration } from '../data/utils/getAnimationDuration';

const INCR_CLASS = 'xs-incr';
const DECR_CLASS = 'xs-decr';

export function highlightOddChange(oldValue, newValue, classList) {
    if (classList) {
		if (newValue == null) {
			classList.remove(INCR_CLASS);
			classList.remove(DECR_CLASS);
		} else if (oldValue != null && oldValue !== newValue) {
			if (newValue > oldValue) {
				classList.remove(DECR_CLASS);
				if (!classList.contains(INCR_CLASS)) {
					classList.add(INCR_CLASS);
				}              
			} else {
				classList.remove(INCR_CLASS);
				if (!classList.contains(DECR_CLASS)) {
					classList.add(DECR_CLASS);
				} 
			}
            const timeout = getAnimationDuration();
            let t = setTimeout(() => {
                if (classList) {
                    classList.remove(INCR_CLASS);
                    classList.remove(DECR_CLASS);
                }
                clearTimeout(t)
            }, timeout);
		}
    }
}

export function useHighlightOddChange(oddContainer, value, enabled) {
    const [, setOddValue] = useState(value);
    useEffect(() => {
        if (!enabled) {
            return;
        }
        const classList = oddContainer.current?.classList;
        setOddValue(prev => {
            highlightOddChange(prev, value, classList);
            return value;
        });
    }, [oddContainer, value, enabled]);
}
